import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { loginRoute } from '../../core/routing/route-names';
import { ActivationGuardBase } from './activation-guard.base';

@Injectable({
  providedIn: 'root',
})
export class ClientActiveGuard extends ActivationGuardBase {
  constructor(private authService: AuthService, private router: Router) {
    super();
  }

  checkLogin(url: string): boolean {
    // Admin and Standard User are not assigned to a client, so client will always be null for them
    if (this.authService.isUserAdmin() || this.authService.isUserStandardUser() || this.authService.getUserInfo().client?.isActive) {
      return true;
    }


    // Store the attempted URL for redirecting
    this.authService.redirectUrl = url;

    // Navigate to the login page with extras
    this.authService.logout();
    this.router.navigate([loginRoute], { queryParams: { error: 'client' } });
    return false;
  }
}
